<template>
  <div id="frame">
    <div class="header" v-if="procDone">
      <p class="cancelButton" @click="close"></p>
      <div class="head">
        <div class="title">
          <span class="bold color-blue">보험료 비교표</span>를 확인하고 견적서 하단의 선호보험사도 선택해보세요!
        </div>

        <div class="section">
          <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length == 0" @click="reservation">추천 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
          <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length > 0" @click="reservation">선호 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
        </div>

        <div class="sub">* 보험료는 가입 시점에 보험 나이 및 병력, 보험사의 인수정책에 따라 달라질 수 있습니다.</div>
      </div>

      <div class="top">
        <div class="table-pagination" :style="procDone ? 'display: inline-flex' : 'display: none'">
          <span>{{ companies.length }}개 보험사</span>
          <div :style="isMobile ? 'display: inline-flex' : 'display: none'">
            <button
              class="pagination-button"
              v-for="(item, idx) in companies"
              :key="idx"
              :class="active === idx ? 'active' : ''"
              @click="movePagination(idx)"
            />
          </div>
        </div>

        <div class="unit" :style="procDone && !isMobile ? 'display: inline-flex' : 'display: none'">
          <span>단위: 만원</span>
        </div>

        <div class="prev-next-btn" :style="procDone && isMobile ? 'display: inline-flex' : 'display: none'">
          <el-button
            size="mini"
            :disabled="active === 0"
            @click="movePagination(active - 1)"
          >
            이전
          </el-button>
          <el-button
            size="mini"
            :disabled="(active + 1) === companies.length"
            @click="movePagination(active + 1)"
          >
            다음
          </el-button>
        </div>
      </div>
      <!-- 보험료 테이블 -->
      <div class="premium-table" v-if="procDone">
        <!-- 좌측 항목 시작 -->
        <div class="column">
          <div class="pt-cell"><span class="bolder">보험사</span></div>
          <div class="pt-cell" v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) == -1)" :key="idx + 'o1'"
            :class="{'line-cover': (item.보장항목 == '일반항목' || item.보장항목 === '합계항목') && item.사용 == '사용', 'blue': highlight항목.indexOf(item.항목명) != -1}">
            <span class="bolder">{{item.항목명}}</span>
          </div>
          
          <div class="line-cover blue pt-cell"><span></span></div>
          <template v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '보장항목' && e.사용 == '사용')">
            <template v-if="useKeys.indexOf(item.항목명) !== -1">
              <div class="pt-cell" :key="idx + 'o2'">
                <span>
                  <el-tooltip placement="right" effect="light" :disabled="!item.설명">
                    <div slot="content" style="white-space: break-spaces;">{{item.설명}}</div>
                    <div class="cst-cell el-cst-hi26">
                      {{item.항목명}} <i class="el-icon-info" v-if="item.설명"></i>
                    </div>
                  </el-tooltip>
                </span>
              </div>
            </template>
          </template>

          <div class="pt-cell" v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) != -1)" :key="idx + 'o3'">
            <span class="bolder">{{item.항목명}}</span>
          </div>
        </div>

        <!-- 보험사 시작 -->
        <div
          class="column compare-company"
          v-for="보험사 in companies"
          :key="보험사"
          :ref="`compare-${보험사}`"
        >
          <template v-if="lifeEstimateCompare['보험사항목정보'][보험사]">
            <div class="pt-cell text-right">
              <img :src="lifeEstimateCompare['보험사정보'][보험사].이미지" style="display: inline-block;width: 24px;max-height: 19px;margin-right: 5px;"/>
              <span class="bolder">{{보험사}}</span>
            </div>

            <div v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) == -1)" :key="idx + 'b1'" class="pt-cell" :class="{'line-cover': (항목.보장항목 == '일반항목' || 항목.보장항목 === '합계항목') && 항목.사용 == '사용', 'blue': highlight항목.indexOf(항목.항목명) != -1}">
              <template v-if="(항목.보장항목 == '일반항목' || 항목.보장항목 === '합계항목') && 항목.사용 == '사용'">
                <template v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] && lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1.indexOf('http') == -1">
                  <div class="text-right">
                    <span class="bolder">
                      {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1 | number}}
                      {{ !isNaN(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1) ? '원' : ''}}
                    </span>
                  </div>
                </template>
              </template>
            </div>

            <template v-if="hip">
              <div class="line-cover blue">
                <div class="text-right">
                  <span class="bolder pt-cell">보험금</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="line-cover blue">
                <div class="col-sep">
                  <div class="row bolder pt-cell text-right"><span>보험금</span></div>
                  <div class="row color-blue bolder pt-cell text-right"><span>보험료</span></div>
                </div>
              </div>
            </template>

            <template v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '보장항목' && e.사용 == '사용')">
              <template v-if="항목.보장항목 == '보장항목' && 항목.사용 == '사용'">
                <template v-if="useKeys.indexOf(항목.항목명) !== -1">
                  <template v-if="hip">
                    <div
                      class="pt-cell right"
                      v-if="!ca && !dc"
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b2'"
                    >
                      <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ? 
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                      </span>
                    </div>

                    <div
                      class="col-sep"
                      v-else
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b2'"
                    >
                      <div class="row pt-cell right">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row right color-blue pt-cell disable">
                        <template v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명]">
                          <span v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].isCalc">
                            {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                              number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                            : 0}}
                          </span>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="col-sep"
                      v-if="dc"
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b2'"
                    >
                      <div class="row pt-cell right">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell right">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>
                    <div class="col-sep" v-else :key="idx + 'b2'">
                      <div class="row pt-cell right">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell right">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>
                    <!--<div class="col-sep" v-else-if="ca">
                      <div class="row pt-cell">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>-->
                  </template>
                </template>
              </template>
            </template>
            <div v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '일반항목' && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) != -1)" :key="idx + 'b3'">
              <div class="pt-cell" style="text-align: center;">
                <el-link :href="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1" target="_blank" type="primary" size="mini">보기</el-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 하단 -->
    <div class="footer" v-if="procDone">
      <div class="title" v-if="selectedCompany.length <= 2">
        <span class="bold color-blue">선호하는 보험사</span>를 선택해주세요!
      </div>
      <div class="title" v-else-if="selectedCompany.length > 2">
        <span class="bold color-blue">선호 보험사</span>는 2개 까지만 체크 가능합니다!
      </div>

      <div class="sub">
        <span>(최대 2개 선택 가능)</span>
      </div>

      <div class="section company">
        <ul class="company-list">
          <li v-for="보험사 in companies" :key="보험사" @click="selectCompany(보험사)">
            <span :class="{active: selectedCompany.indexOf(보험사) != -1}">
              <img :src="$store.state.allianceImgList.find(o => o.name == 보험사) ? $store.state.allianceImgList.find(o => o.name == 보험사).value : null" />
            </span>
          </li>
        </ul>
      </div>
      <div class="section">
        <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length == 0" @click="reservation">추천 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
        <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length > 0" @click="reservation">선호 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
      </div>
    </div>
    <el-dialog id="insu_calc_dlg" :title="insu_money_calc_dlg.title" :visible.sync="insu_money_calc_dlg.visible" width="500px" append-to-body>
      <el-row>
        <el-col :span="12">
          <div class="flex">
            <div class="el-cst-label el-cst-hi26 aligned center highlight type-static-100">보험금</div>
            <div style="margin-left: auto;">
              <el-input-number class="type-static-155" 
                v-model="insu_money_calc_dlg.value" 
                :min="insu_money_calc_dlg.min" 
                :max="insu_money_calc_dlg.max" 
                :step="insu_money_calc_dlg.step"
                @change="InsuMoneyCalcDialogValueChangeHandler"></el-input-number>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex">
            <div class="el-cst-label el-cst-hi26 aligned center highlight type-static-100">보험료</div>
            <div class="el-cst-label el-cst-hi26 aligned center" style="width: 100%;">{{insu_money_calc_dlg.value2 | number}}</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-row class="flex">
          <span class="el-cst-label el-cst-hi26 red">{{insu_money_calc_dlg.label}}</span>
          <el-button class="el-cst-hi28 simple type-static-125" type="primary" style="margin-left: auto;" @click="saveInsuMoneyCalcDialog">저장</el-button>
        </el-row>
      </el-row>
    </el-dialog>

    <div class="spinner-area" ref="spinner">
      <div class="loadingio-spinner-ellipsis-v3ytqcu5wu">
        <div class="sk-text" :class="isMobile ? 'color-black' : 'color-white'">보험료 계산 중</div>
        <div class="ldio-tvytf13gwci">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Divider, InputNumber, Checkbox, Tooltip, Link, Button } from 'element-ui'
import moment from "moment";
import { modalItems } from "@/router/routes";
import lifePremium from "@/mixin/lifePremium"

export default {
  mixins: [ lifePremium ],
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [InputNumber.name]: InputNumber,
    [Checkbox.name]: Checkbox,
    [Tooltip.name]: Tooltip,
    [Link.name]: Link,
    [Button.name]: Button,
  },
  data(){
    return {
      id: '2841804',
      hip: false, // [query 스트링] 보험료 숨김 여부
      ca: false, // [query 스트링] 쿼리스트링 변수를 통한 보험료 계산 여부
      dc: true, // [query 스트링] 보험금 수정가능 여부
      highlight항목: [
        '적립보험료', '보장보험료', '납입보험료(월)'
      ],
      하단고정항목: [
        '상품요약서', '보험약관'
      ],
      lifeEstimateCompare: {
        시트: [],
        보험정보: [],
        보험사정보: {},
        항목정보: [],
        보험사항목정보: {},
        보험사보험료: {},
      },
      lifeEstimateCompareForm: {
        시트url: '',
        보험종목: '',
        나이: 0,
        직업: '1',
        성별: '남자',
      },
      insu_money_calc_dlg: {
        currentItem: null,
        title: '',
        visible: false,
        min: 0,
        max: 0,
        step: 0,
        value: 0,
        value2: 0,
        ratio: 0,
        label: '',
      },
      selectedCompany: [],
      customer: {},
      estimateData: {},
      conditionData: {},
      procDone: false,
      active: 0,
      companies: [],
      firstKey: '운전자-기본',
      startX: 0,
      startY: 0,
      isMobile: this.$store.state.config.isTouchDevice,
      useKeys: [],
      receiver: 'ltw@insunetfc.com'
    }
  },
  async mounted() {
    if(this.$route.query.id) this.id = this.$route.query.id
    this.hip = this.$route.query.hip !== undefined ? true : false
    this.ca = this.$route.query.ca !== undefined ? true : false
    this.dc = this.$route.query.dc !== undefined ? true : false

    if (this.$route.query.ci) {
      this.getCustomer(this.$route.query.ci);
    }

    if(!this.ca) {
      this.init()
    }else{
      if(this.$route.query.ins === undefined) {this.close();return;}
      if(this.$route.query.ag === undefined) {this.close();return;}
      if(this.$route.query.jb === undefined) {this.close();return;}
      if(this.$route.query.sx === undefined) {this.close();return;}
      if(this.$route.query.tb === undefined) {this.close();return;}

      if (this.$store.state.customer.profile._id) {
        this.getCustomer(this.$store.state.customer.profile._id);
      }

      this.lifeEstimateCompareForm.보험종목 = this.$route.query.ins // '운전자'
      this.lifeEstimateCompareForm.나이 = this.$route.query.ag // 29
      this.lifeEstimateCompareForm.직업 = this.$route.query.jb // '1'
      this.lifeEstimateCompareForm.성별 = this.$route.query.sx // '남자'

      this.$store.state.pagename = this.lifeEstimateCompareForm.보험종목.split('-')[0] + '보험';

      this.changeSpreadSheet(this.$route.query.tb) // "15PVCKlLLrrLfxUKJ_lnpS7RspynmY6H28TBu955N5ic"
      await this.initInsuPri()
    }

    window.addEventListener('resize', this.resizeEventHandler);
    window.addEventListener('touchstart', this.touchStartEventHandler);
    window.addEventListener('touchend', this.touchEndEventHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
    window.removeEventListener('touchstart', this.touchStartEventHandler);
    window.removeEventListener('touchend', this.touchEndEventHandler);
  },
  watch: {
    procDone(value) {
      if (value) {
        this.doneSpinner();
        this.uniqueInsuranceDetailInfo();
      }
    },
  },
  methods: {
    number(value) {
      if( value ){
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
        return 0;
      }
    },
    init() {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/estimate.condition/${this.id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.getEstimate(data.estimate_id)
        this.conditionData = data
        var tmp_extra = JSON.parse(data.estimate_condition_extra ? data.estimate_condition_extra : '{}')
        this.conditionData.extra = tmp_extra
        if(tmp_extra['보험료정보']) {
          const tmpObjInfo = tmp_extra.보험료정보.data.보험사항목정보;
          this.lifeEstimateCompare = tmp_extra.보험료정보.data
          // 2022-05-16 상품요약서, 보험약관 뺼필요 없음 
          /*this.lifeEstimateCompare.항목정보 = this.lifeEstimateCompare.항목정보.filter(e => {
            return e.항목명 != '상품요약서' &&  e.항목명 != '보험약관'
          })*/

          Object.keys(tmpObjInfo).map((key, index) => {
            let tmpObj = tmpObjInfo[key];

            if (!tmpObj['운전자-기본']) {
              tmpObj = {
                '운전자-기본': tmpObj
              }
            }

            if (index === 0) {
              this.lifeEstimateCompare['보험사항목정보'][key] = {};
            }
            this.lifeEstimateCompare['보험사항목정보'][key] = tmpObj;

            this.companies.push(key);
          })
          this.procDone = true;
        }
      })
      .catch(e => {
      })
    },
    submitCondition() {
      this.conditionData.estimate_condition_extra = JSON.stringify(this.conditionData.extra);
      this.axios.put(`${this.$store.state.config.hostName}/v1/crm/estimate.condition/edit/${this.id}`, this.conditionData).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
      })
      .catch(e => {
      })
    },
    getEstimate(id) {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/estimate/${id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.getCustomer(data.customerId)
        this.estimateData = data
        this.$store.state.pagename = `${data.estimate_type}보험 견적서`;
        this.getReciever();
        this.sendHangout({ ...data, insuranceType: data.estimate_type });
      })
      .catch(e => {
      })
    },
    getCustomer(id) {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/customer/${id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.customer = data
      })
      .catch(e => {
      })
    },
    close(){
      const isExistModal = Object.keys(modalItems).filter(item => item === this.$route.name);

      if (this.isMobile) {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        let tab = this.$route.query.ins.split('-')[0];
        tab = tab.indexOf('보험') === -1 ?  `${tab}보험` : tab;

        this.$router.replace({ query: { tab }});
      }

      if (isExistModal.length) {
        if (document.referrer) {
          this.$router.push({ name: "Home" });
        }

        history.back();
      } else {
        this.$store.commit( "elementModal/CLEAR_ITEMS" );
        var tab = this.$route.query.tab;
        this.$router.replace({ query: { tab : tab}})
      }
    },
    selectCompany(company) {
      let idx = this.selectedCompany.indexOf(company);
      if(idx === -1) {
        if (this.selectedCompany.length < 2) {
          this.selectedCompany.push(company) 
        }
      }else{
        this.selectedCompany.splice(idx, 1)
      }
    },
    getBirthNumber() {
      const { birth, sx } = this.$route.query;
      const year = birth.split('-')[0] * 1;
      const _birth = birth.split('-').join('').slice(2);
      let gender = { '남자': 1, '여자': 2 }[sx];

      if (year > 1999) {
        gender = gender + 2;
      }

      return _birth + gender;
    },
    async reservation() {
      if (!this.customer._id) {
        this.reservationNoneCustomer();
        return;
      }

      // 다음 평일 09시 예약으로 고정
      let mmD
      let url = 'reservation/createItemsForLifePremium';
      const { date, time } = this.$getDefaultConsultTime();
      let queryItems = this.$route.query;

      let param = {
        adminj: 35,
        admin: this.estimateData.admin_id,
        customer_id: this.estimateData.customerId,
        reservation_name: this.estimateData.customerName,
        reservation_contract: this.customer.customer_phone_number,
        reservation_inflow: '홈페이지',
        reservation_date_request: date.split('.').join('-') + ' ' + time + ':00',
        ip: '',
      }
      let _memo = '';

      if (date === '') {
        param.reservation_date_request = moment(new Date()).format('YYYY-MM-DD') + ' ' + time + ':00';
      }

      if (moment().day() === 5) { // friday, show monday
        // set to monday
        mmD = moment().weekday(8)
      } else if (moment().day() === 6) { // saturday, show monday
        // set to monday
        mmD = moment().weekday(8)
      }else { // other days, show next day
        mmD = moment().add(1, 'days')
      }

      var dcd_ref = ""
      try {
        dcd_ref = decodeURI(window.document.referrer)
      } catch(e) {

      }
      
      if (!this.ca) {
        _memo = "[전화상담예약] " + this.conditionData.extra.condition.설계요청내용.보험종목 + " " + this.estimateData.customerName + "님께서 상담예약하였습니다. 시간에 맞춰 연락하십시오. "
        _memo = _memo + "\n상담내용 : 선호보험사(" + (this.selectedCompany.length > 0 ? this.selectedCompany.join(' , ') : '없음') + ") "
  
        param = {
          ...param,
          reservation_memo: _memo,
          referrer: dcd_ref,
          reservation_type: this.conditionData.extra.condition.설계요청내용.보험종목
        }
      } else {
        let customer_id = '';
        let customer_birth = '';
        let reservation_name = this.$route.query.name ? this.$route.query.name : '';
        let reservation_contract = this.$route.query.phoneNumber ? this.$route.query.phoneNumbe.split('-').join('') : '';

        if (this.$route.query.ci) {
          const {
            _id,
            customer_social_number,
            customer_phone_number,
            customer_name
          } = this.customer;
          customer_id = _id;
          customer_birth = customer_social_number.substring(0, 7);
          reservation_contract = customer_phone_number;
          reservation_name = customer_name;
        } else {
          customer_id = this.$store.state.customer.profile._id;
          customer_birth = this.getBirthNumber();
        }

        let reservation_memo = '추천보험사 상담을 원함';
        url = 'reservation/createItemsForLifePremiumWeb';

        if (this.selectedCompany.length) {
          reservation_memo = `${this.selectedCompany.join(', ')}로 상담을 원함`;
        }

        param = {
          ...param,
          admin: 35,
          customer_id: customer_id ? customer_id : 0,
          customer_birth,
          reservation_contract,
          reservation_type: this.$route.query.ins.split('-')[0],
          reservation_inflow: '홈페이지',
          reservation_name,
          reservation_memo,
          referrer: dcd_ref
        }
      }

      this.$store.dispatch(url, param).then(res => {
        const { error } = res.data;

        if (error) {
          this.$store.commit( "elementSnackbar/SET_ITEM", { message: error, status: "false" } );
          return;
        }

        this.close();
        this.$store.commit("elementModal/SET_ITEM", { elementId: "globalLifeEstimateResult", query: queryItems });
      })
    },
    openInsuMoneyCalcDialog(보험사, 보험사항목정보) {
      if (!this.dc || 보험사항목정보 === undefined) {
        return;
      }

      let 보험료정보 = this.lifeEstimateCompare['보험사보험료'][보험사][보험사항목정보.항목명]
      this.insu_money_calc_dlg.title = 보험사 + ' - ' + 보험료정보.보험사항목명
      
      this.insu_money_calc_dlg.min = Number(보험사항목정보.데이터1)
      this.insu_money_calc_dlg.max = Number(보험사항목정보.데이터2)
      this.insu_money_calc_dlg.step = Number(보험사항목정보.데이터3)
      this.insu_money_calc_dlg.value = Number(보험사항목정보.데이터4)
      this.insu_money_calc_dlg.label = 보험사항목정보.데이터5
      this.insu_money_calc_dlg.value2 = Number(보험료정보.데이터1)

      this.insu_money_calc_dlg.currentItem = {
        보험사: 보험사,
        보험료정보: 보험료정보,
        보험사항목정보: 보험사항목정보,
      }
      
      보험사항목정보.isCalc = true;

      this.insu_money_calc_dlg.ratio = Number(보험료정보.기준보험료) / Number(보험사항목정보.기준보험금)
      this.insu_money_calc_dlg.visible = true
    },
    InsuMoneyCalcDialogValueChangeHandler(currentValue, oldValue) {
      this.insu_money_calc_dlg.value2 = Math.floor(currentValue * this.insu_money_calc_dlg.ratio)
    },
    saveInsuMoneyCalcDialog() {
      this.insu_money_calc_dlg.visible = false
      this.insu_money_calc_dlg.currentItem.보험료정보.데이터1 = this.insu_money_calc_dlg.value2
      this.insu_money_calc_dlg.currentItem.보험사항목정보.데이터4 = this.insu_money_calc_dlg.value
      this.calcExtraInsurancePri(this.insu_money_calc_dlg.currentItem.보험사)
      
      if(this.ca || !this.id) this.submitCondition()
    },
    calcExtraInsurancePri(보험사) {
      let 기본보험료item = this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['기본보험료']
      let 기본보험료 = Number(기본보험료item.데이터1)
      let 보장보험료 = Object.values(this.lifeEstimateCompare.보험사보험료[보험사]).map( e => Number(e.데이터1) ).reduce((previousValue, currentValue) => {
        return previousValue + currentValue
      })
      let 적립보험료 = 0
      if(기본보험료 > 보장보험료) {
        적립보험료 = 기본보험료 - 보장보험료
      } else if(기본보험료 == 보장보험료) {
        적립보험료 = 0
      }else{
        적립보험료 = (Math.ceil(보장보험료 / 10) * 10 - 보장보험료)
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['보장보험료'].데이터1 = 보장보험료.toString()
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['적립보험료'].데이터1 = 적립보험료.toString()
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['납입보험료(월)'].데이터1 = (보장보험료 + 적립보험료).toString();
    },
    /**/
    async initInsuPri() {
      this.procDone = false
      
      let 보험종목 = this.lifeEstimateCompareForm.보험종목

      this.lifeEstimateCompare = {
        시트: [],
        보험정보: [],
        보험사정보: {},
        항목정보: [],
        보험사항목정보: {},
        보험사보험료: {},
      }

      this.startSpinner();
      await this.getSpreadInsuranceInfo(보험종목)
      await this.calcInsuPriProc(보험종목)
      // 2022-05-16 상품요약서, 보험약관 뺼필요 없음 
      /*this.lifeEstimateCompare.항목정보 = this.lifeEstimateCompare.항목정보.filter(e => {
        return e.항목명 != '상품요약서' &&  e.항목명 != '보험약관'
      })*/
      this.procDone = true
      this.companies = Object.keys(this.lifeEstimateCompare['보험사보험료']);
      fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
        this.sendHangout({ customerName: ip, insuranceType: 보험종목.split('-')[0] });
      });
    },
    async calcInsuPriProc(보험종목) {
      const insureType = {
        '운전자-기본': '운전자'
      }[this.lifeEstimateCompareForm.보험종목] || this.lifeEstimateCompareForm.보험종목;
      const promises = []
      for(let i = 0; i < this.lifeEstimateCompare.보험정보.length; i++) {
        promises.push((async () => {
          let company = this.lifeEstimateCompare.보험정보[i]
          await this.getSpreadCompanyInfo(company)
          await this.getSpreadCompCategoryDetailInfo(보험종목, company, this.lifeEstimateCompareForm.성별, this.lifeEstimateCompareForm.직업)
          await this.getSpreadCompInsurancePri(insureType, company, this.lifeEstimateCompareForm.성별, this.lifeEstimateCompareForm.직업, this.lifeEstimateCompareForm.나이.toString())
        })())
      }
      await Promise.all(promises);
      await this.getSpreadInsuranceDetailInfo(보험종목);
    },
    calcInsurancePri(보험사, 항목명) {
      // if (this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey][항목명]) {
        let cvRatio = Number(this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey][항목명].기준보험금) / Number(this.lifeEstimateCompare.보험사보험료[보험사][항목명].보험료기준)
        this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 = this.lifeEstimateCompare.보험사보험료[보험사][항목명].기준보험료
          = Math.floor(this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 *  cvRatio)
      // }
      
      /*let ratio = Number(this.lifeEstimateCompare.보험사보험료[보험사][항목명].기준보험료) / Number(this.lifeEstimateCompare.보험사항목정보[보험사][항목명].기준보험금)
      this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 = Math.floor(this.lifeEstimateCompare.보험사항목정보[보험사][항목명].데이터4 * ratio)*/
    },
    createExtraInsurancePriItem(보험종목, 보험사, 성별, 등급) {
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['보장보험료'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '보장보험료',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['적립보험료'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '적립보험료',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['납입보험료(월)'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '납입보험료(월)',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
    },
    resizeEventHandler() {
      const { userAgent } = window.navigator;
      const tables = document.querySelectorAll('.compare-company');

      this.isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

      if (!this.isMobile) {
        for (let i = 0; i < tables.length; i++) {
          tables[i].style.display = 'block';
        }
      } else {
        this.movePagination(this.active);
      }
    },
    movePagination(idx) {
      const paginations = document.querySelectorAll('.pagination-button');
      const tables = document.querySelectorAll('.compare-company');
      this.active = idx;

      for (let i = 0; i < paginations.length; i++) {
        paginations[i].classList.remove('active');
        tables[i].style.display = 'none';
      }

      paginations[idx].classList.add('active');
      tables[idx].style.display = 'block';
    },
    startSpinner() {
      this.$refs.spinner.style.display = 'block';
    },
    doneSpinner() {
      this.$refs.spinner.style.display = 'none';
    },
    touchStartEventHandler(e) {
      const { touches } = e;
      this.startX = touches[0].clientX;
      this.startY = touches[0].clientY;
    },
    touchEndEventHandler(e) {
      const { target, changedTouches } = e;
      const { clientX, clientY } = changedTouches[0];
      const isTable = target.closest('.premium-table');
      const absX = Math.abs(this.startX - clientX);
      const absY = Math.abs(this.startY - clientY);
      let activePage = this.active * 1;

      if (clientX < this.startX) {
        activePage = activePage + 1;
      }

      if (clientX > this.startX) {
        activePage = activePage - 1;
      }

      if (activePage === this.companies.length || activePage === -1) {
        return;
      }

      if (absX < absY) {
        return;
      }

      if (isTable) {
        this.movePagination(activePage);
      }
    },
    reservationNoneCustomer() {
      let reservation_memo = '추천보험사 상담을 원함';
      if (this.selectedCompany.length) {
        reservation_memo = `${this.selectedCompany.join(', ')}로 상담을 원함`;
      }

      const options = {
        name: 'Consultation',
        query: {
          isDateTime: true,
          consultRemark: reservation_memo
        }
      };

      this.$router.push(options);
    },
    uniqueInsuranceDetailInfo() {
      const companies = this.companies;
      let insuranceItems = [];
      companies.map(company => {
        const obj = this.lifeEstimateCompare.보험사항목정보[company][this.firstKey];
        const arr = Object.keys(obj).filter(key => obj[key].데이터1 !== 0);

        insuranceItems.push(arr);
      });

      const useKeys = Array
        .prototype
        .concat
        .apply([], insuranceItems)
        .reduce((prev, cur) => {
          if (prev.indexOf(cur) === -1) {
            prev.push(cur);
          }

          return prev;
        }, []);

      this.useKeys = useKeys;
    },
    getReciever() {
      if (!this.ca) {
        this.receiver = this.estimateData.admin_email;
      }
    },
    sendHangout({customerName, customerId, insuranceType}) {
      let content = `[홈페이지 견적서 방문] ${insuranceType}보험 차량 ${customerName}고객님께서 ${insuranceType}보험 보험료 비교표를 확인 중입니다./${this.id || 0}/${customerId || 0}`;

      // if (this.ca) {
      //   content = `[홈페이지 견적서 방문] ${customerName}고객님(${this.$route.query.ag}세 ${this.$route.query.sx} ${this.$route.query.jb})께서 ${insuranceType}보험 보험료 비교표를 확인 중입니다.`;
      // }

      this.$store.dispatch("etc/sendHangout", {
        rp: this.receiver,
        mg: content
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  #frame {
    background-color: white;
    .header{
      margin: 0 auto;
      padding: 50px;
      .cancelButton{
          width: 2rem;
          height: 2rem;
          background-image: url(/static/images/connection/close-white.png);
          background-size: 1rem;
          background-repeat: no-repeat;
          background-position: center;
          font-size: 16px;
          font-weight: 600;
          position: absolute;
          right: 20px;
          top: 2rem;
          cursor: pointer;
          background-color: #174de533;
          border-radius: 100%;
      }
      .head {
        margin-bottom: 20px;
        .title {
          font-size: 30px;
        }
        .sub {
          font-weight: 300;
          font-size: 15px;
        }

        .section {
          text-align: center;
          margin: 20px auto;

          &.company {
            margin-top: 20px;
          }
          .button.reservation {
            height: 65px;
            width: 241px;
            background: #174de5;
            line-height: 65px;
            text-align: center;
            margin: 0 auto;
            color: white;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              background: #959595;
            }
            img {
              display: inline;
              margin-left: 30px;
              top: -3px;
            }
          }
        }
      }

      .top {
        display: block;
        position: sticky;
        top: -27px;
        padding-bottom: 0.5*$unit;
        background-color: #fff;
        z-index: 1000;

        .table-pagination {
          display: inline-flex;
          position: relative;
          align-items: center;
  
          span {
            margin-right: 0.5*$unit;
            font-size: $unit;
          }
          .pagination-button {
            width: 1*$unit;
            height: 1*$unit;
            float: left;
            margin-right: 12px;
            background-color: #e6e6e6;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s ease width;
            &.active {
              width: 2*$unit;
              background-color: #174de5;

              &:nth-child(3n + 2) {
                background-color: #d74946;
              }
              &:nth-child(3n + 3) {
                background-color: #b2a924;
              }
            }
          }

          @media screen and (max-width: 320px) {
            span {
              font-size: 12px;
            }
          }
        }
  
        .unit,
        .prev-next-btn {
          float: right;

          @media screen and (max-width: 320px) {
            button {
              font-size: 10px;

              &:last-child {
                margin-left: 5px;
              }
            }
            
          }
        }

        @include media-mobile {
          top: 0px;
        }
      }
      
      .premium-table {
        display: flex;
        font-size: 12px;
        font-weight: 300;
        .column {
          flex: 1;
          & span {
            white-space: nowrap;
            cursor: pointer;
          }
          .align-center {
            display: flex;
            align-items: center;
          }
          .text-right {
            text-align: right;
          }
          .text-center {
            text-align: center;
          }
          .col-sep {
            display: flex;
            .row {
              flex: 1;
            }
          }
          & > div {
            &:first-child {
              border-top: 1px solid #eaeaea;
              position: sticky;
              top: 0px;
              z-index: 1000;
              background-color: #fff;

              @include media-mobile {
                top: 30px;
              }
            }
            border-bottom: 1px solid #eaeaea;
            height: 40px;
            line-height: 40px;
          }
          .pt-cell {
            padding: 0 15px;
            &.right {
              text-align: right;
            }
            &.disable {
              display: none;
            }
          }
        }
        .bolder {
          font-weight: 800;
        }
        .line-cover {
          background: #fffff6;
          &.blue {
            background: #f5f8ff;
          }
        }

        @include media-mobile {
          flex-wrap: wrap;

          .column {
            flex: 0 1 50%;
            width: 50%;

            &.compare-company:nth-child(n+3) {
              display: none;
            }
          }
        }
      }

      @media screen and (max-width: 320px) {
        padding-right: 0.5*$unit !important;
      }
    }
    
    .bold {
      font-weight: bold;
    }
    .color-blue {
      color: #174de5;
    }
    .footer {
      background: #e7edfc;
      padding: 25px;
      .title {
        text-align: center;
        font-size: 24px;
      }
      .sub {
        text-align: center;
        font-size: 15px;
      }
      .company-list {
        display: inline-flex;
        padding: 0 20px;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        li {
          margin: 15px;
          span {
            padding: 8px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: white;
            height: 79px;
            width: 79px;
            border-radius: 23%;
            border: 2px solid transparent;
            &.active {
              border: 2px solid #174de5;
            }
            & > img {
              max-height: 100%;
            }
          }
        }
      }
      .section {
        text-align: center;
        &.company {
          margin-top: 20px;
        }
        .button.reservation {
          height: 65px;
          width: 241px;
          background: #174de5;
          line-height: 65px;
          text-align: center;
          margin: 0 auto;
          color: white;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          &.disabled {
            cursor: not-allowed;
            background: #959595;
          }
          img {
            display: inline;
            margin-left: 30px;
            top: -3px;
          }
        }
      }
    }

    @include media-mobile {
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 11px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #174de5;
      }
      &::-webkit-scrollbar-track {
        background-color: #e7edfc;
      }
      .header {
        padding: 50px $unit $unit $unit;

        .head {
          margin-bottom: 1.5*$unit;
        }
      }
    }
  }
</style>
<style lang="scss">
  #insu_calc_dlg {
    .el-dialog__headerbtn {
      width: auto;
    }
  }

  .element-snackbar {
    bottom: 3%;
  }



  .spinner-area {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    left: 0;
    margin: auto;
    background-color: transparent;
    opacity: 1;
  
    > div {
      top: calc(50% - 100px);
      left: calc(50% - 100px);

      @include media-mobile {
        top: calc(50% - 100px);
      }
    }

    .sk-text {
      position: relative;
      text-align: center;
      top: 30%;
      font-size: 1.5*$unit;
      color: #fff;

      &.color-black {
        color: #000;
      }
      &.color-white {
        color: #fff;
      }
    }

    @keyframes ldio-tvytf13gwci {
      0% {
        transform: translate(12px, 80px) scale(0);
      }
    
      25% {
        transform: translate(12px, 80px) scale(0);
      }
    
      50% {
        transform: translate(12px, 80px) scale(1);
      }
    
      75% {
        transform: translate(80px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(1);
      }
    }
    
    @keyframes ldio-tvytf13gwci-r {
      0% {
        transform: translate(148px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(0);
      }
    }
    
    @keyframes ldio-tvytf13gwci-c {
      0% {
        background: #d74946
      }
    
      25% {
        background: #94b224
      }
    
      50% {
        background: #f0af31
      }
    
      75% {
        background: #0069ce
      }
    
      100% {
        background: #d74946
      }
    }
    
    .ldio-tvytf13gwci div {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      transform: translate(80px, 80px) scale(1);
      background: #d74946;
      animation: ldio-tvytf13gwci 1s infinite cubic-bezier(0, 0.5, 0.5, 1);
    }
    
    .ldio-tvytf13gwci div:nth-child(1) {
      background: #0069ce;
      transform: translate(148px, 80px) scale(1);
      animation: ldio-tvytf13gwci-r 0.25s infinite cubic-bezier(0, 0.5, 0.5, 1), ldio-tvytf13gwci-c 1s infinite step-start;
    }
    
    .ldio-tvytf13gwci div:nth-child(2) {
      animation-delay: -0.25s;
      background: #d74946;
    }
    
    .ldio-tvytf13gwci div:nth-child(3) {
      animation-delay: -0.5s;
      background: #0069ce;
    }
    
    .ldio-tvytf13gwci div:nth-child(4) {
      animation-delay: -0.75s;
      background: #f0af31;
    }
    
    .ldio-tvytf13gwci div:nth-child(5) {
      animation-delay: -1s;
      background: #94b224;
    }
    
    .loadingio-spinner-ellipsis-v3ytqcu5wu {
      width: 200px;
      height: 200px;
      display: inline-block;
      overflow: hidden;
    }
    
    .ldio-tvytf13gwci {
      width: 100%;
      height: 100%;
      position: relative;
      transform: translateZ(0) scale(1);
      backface-visibility: hidden;
      transform-origin: 0 0;
      /* see note above */
    }
    
    .ldio-tvytf13gwci div {
      box-sizing: content-box;
    }
    
    /* generated by https://loading.io/ */
  }
</style>